import { AxiosError, AxiosResponse } from "axios";

export class AlertError {
  constructor(public message: string, public messages?: Array<string | JSX.Element>) {}
}

export class FetchError extends AlertError {
  data: Message;
  error: AxiosResponse;

  constructor(error: AxiosError) {
    const messages: string[] = [];
    let code: number | string;
    let titleMsg: string;
    const message = error.response ? error.response.statusText : "Request failed";
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data: any = error.response ? error.response.data : undefined;
    if (!data) {
      code = error.response ? error.response.status : "NETWORK";
      titleMsg = message;
    } else {
      code = data.code;
      titleMsg = data.message;
    }

    const title = `Error ${code}: ${titleMsg}`;
    messages.push(`Status: ${message}`);
    if (error.config) {
      messages.push(`URL: ${error.config.url}`);
    } else {
      messages.push(error.message);
    }

    super(title, messages);
    this.data = data;
    this.error = error.response;
  }
}

export class Message {
  constructor(public code: number, public message: string, public constraintExceptions?: {}) {}
}
